import React, { FC, ReactNode } from 'react';
import { Button, Row } from '@wunder-mobility/ui-components';
import { Trans } from '@lingui/react/macro';
import styles from '@/core/assets/scss/components/UI/ModalActionsFooter.module.scss';
import { useFormikContext } from 'formik';

interface ModalActionsFooterT {
  onClose?: () => void;
  submitText?: string | ReactNode;
  cancelText?: string | ReactNode;
}

const ModalActionsFooter: FC<ModalActionsFooterT> = ({ onClose, cancelText, submitText }) => {
  const { submitForm, dirty, isValid, isSubmitting } = useFormikContext();

  return (
    <Row className={styles['modal-actions']} justify="flex-end">
      <Button onClick={onClose} variation="secondary">
        {cancelText || <Trans id="general.cancel">Cancel</Trans>}
      </Button>
      <Button loading={isSubmitting} disabled={!(dirty && isValid)} onClick={submitForm}>
        {submitText || <Trans id="general.submit">Submit</Trans>}
      </Button>
    </Row>
  );
};

export default ModalActionsFooter;
